<template>
  <template v-if="shouldShowTextStatus(status)">
    <div
      :class="['status-icon-not-claimed', { 'no-margin': noMargin }]"
      :aria-label="getStatusAccessibilityLabel(status)"
    >
      {{ getStatusText(status) }}
    </div>
  </template>
  <template v-else>
    <v-icon
      :color="getStatusColor(status)"
      icon="mdi-circle"
      :size="16"
      :aria-label="getStatusAccessibilityLabel(status)"
      :style="{ 'margin-right': noMargin ? '0' : '8px' }"
    ></v-icon>
  </template>
</template>

<script setup lang="ts">
  import { useStatusIcons } from '../../composables/useStatusIcons';

  const props = withDefaults(
    defineProps<{
      status: string | undefined;
      noMargin?: boolean;
    }>(),
    {
      noMargin: false,
    },
  );

  const {
    getStatusColor,
    getStatusAccessibilityLabel,
    shouldShowTextStatus,
    getStatusText,
  } = useStatusIcons();
</script>
